import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  return (
    <SiteLayout>
      <div className="pt-16 md:pt-[72px]">
        <div className="max-w-[1240px] mx-auto px-4 md:px-10 py-24 md:py-32 text-center">
          <p className="font-heading text-[5rem] md:text-[8rem] font-bold leading-none text-primary-500/25 select-none">
            404
          </p>
          <h1 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            这份档案不存在
          </h1>
          <p className="mt-4 text-sm md:text-base text-foreground-600">
            页面可能已经调整了地址，或者你输入的链接有误。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-home-4-line" aria-hidden="true"></i>
              回到首页
            </Link>
            <Link
              to="/cases"
              className="inline-flex items-center gap-2 px-6 py-3.5 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-folder-open-line" aria-hidden="true"></i>
              浏览调查档案
            </Link>
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}